import backgroundWEBP from './assets/background.webp';

import { Card } from '@capra/core';
import { Result } from 'antd';
import styled from 'styled-components';

export const Container = styled.main`
  display: flex;
  background: no-repeat url(${backgroundWEBP.src}) center / cover;
  min-height: 100vh;
`;

export const InvitationCard = styled(Card)`
    display: flex;  
    justify-content: center;
    min-height: 450px;
    width: 100%;
    max-width: 500px;
    border: none;
    margin: auto !important;
    border-radius: 2px;
    color: #000000;
    background-color: #ffffff;
    text-align: center;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
    padding: 40px 2em;
  
    @media only screen and (max-width: 768px) {
        width: 100%;
        height: 450px;
    }
`;

export const StatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
`;

export const StatusTitle = styled.h1`
  color: #000000;
  font-size: 1.5rem;
  font-weight: 400;
`;

export const InviteResult = styled(Result)`
    padding: 16px !important;
    color: black !important;
`;

export const InviteSpinWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
`;
